import { render, staticRenderFns } from "./ancestors_tree.vue?vue&type=template&id=d1d19874&"
import script from "./ancestors_tree.vue?vue&type=script&lang=js&"
export * from "./ancestors_tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports